import { render, staticRenderFns } from "./yowhatsapp.vue?vue&type=template&id=f6b787e0&scoped=true"
import script from "./yowhatsapp.vue?vue&type=script&lang=js"
export * from "./yowhatsapp.vue?vue&type=script&lang=js"
import style0 from "./yowhatsapp.vue?vue&type=style&index=0&id=f6b787e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b787e0",
  null
  
)

export default component.exports